export const poverty: [number, number][] = [
  [5.789160499410599, 2.2939433795612736],
  [4.289160499410599, 3.993942235152094],
  [2.489161262350052, 4.193942998091547],
  [6.789160499410599, 1.993942235152094],
  [0.4891612623500521, 4.993942235152094],
  [7.989161262350052, 1.8939418536823673],
  [0.9891612623500521, 3.7939433795612736],
  [2.089159736471146, 4.693942998091547],
  [7.189162025289505, 1.2939433795612736],
  [0.4891612623500521, 4.0939426166218205],
  [6.989161262350052, 2.693942998091547],
  [2.789160499410599, 3.493942235152094],
  [6.389158973531693, 2.7939433795612736],
  [4.3891608808803255, 4.793943379561274],
  [5.589159736471146, 1.5939426166218205],
  [6.389158973531693, 3.2939433795612736],
  [-0.21083950058940104, 4.5939426166218205],
  [7.389158973531693, 1.7939433795612736],
  [3.789160499410599, 3.7939433795612736],
  [4.8891608808803255, 4.393941853682367],
  [-2.210839500589401, 6.293943379561274],
  [5.289160499410599, 2.693942998091547],
  [4.289160499410599, 3.193942998091547],
  [4.989161262350052, 3.2939433795612736],
  [3.1891601179408724, 3.993942235152094],
  [-0.21083950058940104, 5.493942235152094],
  [1.1891601179408724, 4.5939426166218205],
  [3.489161262350052, 1.3939418536823673],
  [4.689160117940872, 2.5939426166218205],
  [7.789160499410599, 1.2939433795612736],
  [3.589159736471146, 3.2939433795612736],
  [4.789160499410599, 3.7939433795612736],
  [2.589159736471146, 2.193942998091547],
  [3.089159736471146, 2.7939433795612736],
  [5.789160499410599, 3.5939426166218205],
  [3.089159736471146, 4.693942998091547],
  [6.389158973531693, 2.2939433795612736],
  [1.6891601179408724, 4.0939426166218205],
  [5.8891608808803255, 1.193942998091547],
  [4.189160117940872, 2.5939426166218205],
  [7.489161262350052, 2.3939418536823673],
  [3.589159736471146, 2.493942235152094],
  [3.789160499410599, 4.493942235152094],
  [4.489161262350052, 1.193942998091547],
  [3.989161262350052, 1.193942998091547],
  [-1.1108391191196745, 5.293943379561274],
  [-0.3108398820591276, 6.493942235152094],
  [3.789160499410599, 5.193942998091547],
  [6.589159736471146, 1.2939433795612736],
  [5.689160117940872, 3.0939426166218205],
  [5.3891608808803255, 3.8939418536823673],
  [3.089159736471146, 1.993942235152094],
  [1.3891608808803255, 3.2939433795612736],
  [8.889158973531693, 1.2939433795612736],
  [5.089159736471146, 1.0939426166218205],
  [2.089159736471146, 3.493942235152094],
  [1.8891608808803255, 2.693942998091547],
  [3.789160499410599, 1.8939418536823673],
  [2.489161262350052, 2.8939418536823673],
  [4.8891608808803255, 1.693942998091547],
  [6.189160117940872, 1.693942998091547],
  [-1.210839500589401, 6.293943379561274],
  [8.289160499410599, 1.3939418536823673],
  [5.289160499410599, 2.0939426166218205],
  [4.3891608808803255, 1.993942235152094],
  [-10.410839309854538, 0.4939422351520939],
  [-11.310839882059128, 0.4939422351520939],
  [-10.010839691324264, 0.4939422351520939],
  [-10.910839309854538, 0.4939422351520939],
  [-9.510838737649948, 0.4939422351520939],
  [-11.810839882059128, 0.4939422351520939],
  [-7.310839882059128, -4.506057764847906],
  [-8.610839119119674, -10.206056620438726],
  [-4.1108391191196745, 1.693942998091547],
  [2.089159736471146, -7.4060573833781795],
  [-7.710839500589401, -6.506057764847906],
  [-8.510838737649948, -4.706056620438726],
  [-5.410840263528854, -7.9060573833781795],
  [0.789160499410599, -1.2060566204387264],
  [-5.810839882059128, -8.206056620438726],
  [0.789160499410599, -4.806057001908453],
  [-7.310839882059128, -5.606058146317633],
  [-6.910840263528854, -7.9060573833781795],
  [-5.710839500589401, -11.006055857499273],
  [-0.3108398820591276, -8.006055857499273],
  [-8.010838737649948, -5.206056620438726],
  [-7.410840263528854, -5.106058146317633],
  [0.6891601179408724, -2.9060573833781795],
  [-9.110839119119674, -9.206056620438726],
  [0.9891612623500521, -8.40605738337818],
  [-9.110839119119674, -4.9060573833781795],
  [1.989161262350052, -3.7060566204387264],
  [-9.110839119119674, -10.206056620438726],
  [1.489161262350052, -8.606058146317633],
  [0.08915973647114583, -9.306058909257086],
  [-5.710839500589401, 0.5939426166218205],
  [-9.110839119119674, -2.9060573833781795],
  [-4.410840263528854, -10.106058146317633],
  [1.289160499410599, -2.4060573833781795],
  [-6.410840263528854, 1.693942998091547],
  [-3.910840263528854, -9.90605738337818],
  [0.3891608808803255, -10.40605738337818],
  [-8.510838737649948, -8.106058146317633],
  [-2.8108398820591276, -10.806058909257086],
  [-4.410840263528854, -9.006055857499273],
  [-7.1108391191196745, -10.606058146317633],
  [-4.1108391191196745, -9.506055857499273],
  [0.6891601179408724, -3.6060581463176327],
  [-0.010838737649947916, -10.806058909257086],
  [0.6891601179408724, -8.006055857499273],
  [1.3891608808803255, 1.7939433795612736],
  [-6.510838737649948, -10.006055857499273],
  [0.6891601179408724, -11.506055857499273],
  [-2.410840263528854, -9.706056620438726],
  [-3.8108398820591276, -8.90605738337818],
  [0.9891612623500521, 0.5939426166218205],
  [1.0891597364711458, -11.206056620438726],
  [-1.8108398820591276, -11.006055857499273],
  [0.8891608808803255, -9.706056620438726],
  [0.9891612623500521, -0.306057001908453],
  [-6.710839500589401, -9.40605738337818],
  [-1.4108402635288542, -8.106058146317633],
  [-0.9108402635288542, -8.006055857499273],
  [-9.110839119119674, -11.006055857499273],
  [-3.410840263528854, -9.90605738337818],
  [-8.310839882059128, 0.7939433795612736],
  [-8.110839119119674, -6.806057001908453],
  [-1.210839500589401, 1.993942235152094],
  [-6.710839500589401, 0.8939418536823673],
  [-2.910840263528854, -9.106058146317633],
  [-1.210839500589401, -10.006055857499273],
  [-1.9108402635288542, -10.306058909257086],
  [-6.010838737649948, 2.693942998091547],
  [-2.510838737649948, -11.40605738337818],
  [-8.010838737649948, -7.806058909257086],
  [-8.410840263528854, -8.706056620438726],
  [-7.410840263528854, 1.5939426166218205],
  [-6.6108391191196745, -11.006055857499273],
  [1.6891601179408724, -11.206056620438726],
  [-3.410840263528854, -8.006055857499273],
  [-0.9108402635288542, -10.506055857499273],
  [-0.8108398820591276, 1.0939426166218205],
  [-2.910840263528854, -11.506055857499273],
  [0.28916049941059896, -11.506055857499273],
  [-1.6108391191196745, -11.506055857499273],
  [1.3891608808803255, -3.306057001908453],
  [-1.210839500589401, -11.006055857499273],
  [-5.210839500589401, 1.7939433795612736],
  [-1.4108402635288542, -10.506055857499273],
  [-4.710839500589401, -9.706056620438726],
  [0.4891612623500521, -8.706056620438726],
  [-0.6108391191196745, -8.506055857499273],
  [0.5891597364711458, -10.90605738337818],
  [-7.710839500589401, -8.90605738337818],
  [-2.210839500589401, 1.693942998091547],
  [-6.710839500589401, -10.506055857499273],
  [-7.310839882059128, -3.2060566204387264],
  [-8.010838737649948, -9.306058909257086],
  [-6.6108391191196745, -8.90605738337818],
  [-1.3108398820591276, -9.40605738337818],
  [-5.710839500589401, -11.506055857499273],
  [-5.910840263528854, -10.006055857499273],
  [-1.710839500589401, -9.806058909257086],
  [-7.310839882059128, -8.506055857499273],
  [0.5891597364711458, -6.106058146317633],
  [-5.6108391191196745, -10.40605738337818],
  [-8.610839119119674, -7.4060573833781795],
  [-3.910840263528854, -11.506055857499273],
  [1.8891608808803255, -0.0060577648479061],
  [-6.1108391191196745, -10.90605738337818],
  [-4.210839500589401, -0.40605738337817954],
  [-0.010838737649947916, 0.39394185368236734],
  [-4.410840263528854, -11.606058146317633],
  [1.489161262350052, -10.106058146317633],
  [1.489161262350052, -4.806057001908453],
  [-8.510838737649948, -5.506057764847906],
  [-5.810839882059128, -0.5060577648479061],
  [-0.710839500589401, -10.006055857499273],
  [-2.3108398820591276, -8.006055857499273],
  [-0.010838737649947916, -10.106058146317633],
  [-0.6108391191196745, -0.306057001908453],
  [0.6891601179408724, -2.006057764847906],
  [-7.810839882059128, -5.806057001908453],
  [-8.410840263528854, -6.106058146317633],
  [-3.210839500589401, -10.506055857499273],
  [2.1891601179408724, -10.90605738337818],
  [-4.810839882059128, 3.0939426166218205],
  [-3.6108391191196745, 3.7939433795612736],
  [-5.210839500589401, -8.506055857499273],
  [-6.910840263528854, -0.6060581463176327],
  [-3.3108398820591276, 0.19394299809154703],
  [-8.010838737649948, -4.506057764847906],
  [-7.1108391191196745, -11.206056620438726],
  [-0.3108398820591276, -9.606058146317633],
  [-9.010838737649948, -2.006057764847906],
  [-5.010838737649948, -0.306057001908453],
  [-2.3108398820591276, -10.306058909257086],
  [1.6891601179408724, -10.606058146317633],
  [-7.210839500589401, -6.306057001908453],
  [-6.1108391191196745, -10.40605738337818],
  [-3.210839500589401, -0.5060577648479061],
  [-6.410840263528854, 0.09394261662182046],
  [-7.1108391191196745, -10.006055857499273],
  [-4.310839882059128, -11.106058146317633],
  [-0.8108398820591276, -9.40605738337818],
  [-0.710839500589401, -11.106058146317633],
  [-4.910840263528854, 0.7939433795612736],
  [-8.910840263528854, -10.606058146317633],
  [-6.210839500589401, -7.9060573833781795],
  [1.5891597364711458, -7.106058146317633],
  [1.989161262350052, -2.006057764847906],
  [-9.110839119119674, -5.706056620438726],
  [-1.010838737649948, 3.2939433795612736],
  [-8.910840263528854, -4.206056620438726],
  [-7.6108391191196745, -10.306058909257086],
  [-3.8108398820591276, -10.90605738337818],
  [-3.510838737649948, -9.306058909257086],
  [0.6891601179408724, -4.206056620438726],
  [-8.010838737649948, -3.9060573833781795],
  [-4.510838737649948, -8.506055857499273],
  [1.289160499410599, -4.106058146317633],
  [-3.3108398820591276, -11.006055857499273],
  [-4.910840263528854, -8.90605738337818],
  [0.1891601179408724, -8.106058146317633],
  [-2.6108391191196745, -8.606058146317633],
  [-5.1108391191196745, -9.40605738337818],
  [-4.310839882059128, -10.606058146317633],
  [-7.310839882059128, -9.506055857499273],
  [-8.610839119119674, -9.106058146317633],
  [-4.1108391191196745, 0.5939426166218205],
  [-3.410840263528854, -11.506055857499273],
  [-2.1108391191196745, -8.706056620438726],
  [1.3891608808803255, -11.606058146317633],
  [2.089159736471146, -10.306058909257086],
  [-9.110839119119674, -7.006055857499273],
  [-0.41084026352885417, -10.606058146317633],
  [2.089159736471146, -9.706056620438726],
  [1.6891601179408724, -9.206056620438726],
  [-1.6108391191196745, -8.806058909257086],
  [-7.510838737649948, -10.90605738337818],
  [1.989161262350052, -2.9060573833781795],
  [-7.310839882059128, -6.9060573833781795],
  [-3.8108398820591276, -8.40605738337818],
  [-7.410840263528854, -11.606058146317633],
  [-8.210839500589401, -11.606058146317633],
  [-8.110839119119674, -2.1060581463176327],
  [-2.8108398820591276, -10.106058146317633],
  [-9.110839119119674, -7.606058146317633],
  [1.5891597364711458, -6.4060573833781795],
  [-7.310839882059128, -3.806057001908453],
  [-2.210839500589401, -0.5060577648479061],
  [-5.410840263528854, -9.806058909257086],
  [-0.5108387376499479, -9.006055857499273],
  [-8.410840263528854, -10.90605738337818],
  [1.989161262350052, -4.306057001908453],
  [-8.010838737649948, -10.706056620438726],
  [0.5891597364711458, -7.4060573833781795],
  [-3.3108398820591276, 2.2939433795612736],
  [-7.510838737649948, -8.006055857499273],
  [-9.010838737649948, -8.606058146317633],
  [-7.410840263528854, 0.2939433795612736],
  [1.489161262350052, -8.006055857499273],
  [-9.110839119119674, -6.306057001908453],
  [-9.010838737649948, -9.706056620438726],
  [0.4891612623500521, -9.806058909257086],
  [-4.710839500589401, -8.006055857499273],
  [-8.310839882059128, -3.4060573833781795],
  [2.1891601179408724, -9.106058146317633],
  [2.089159736471146, -7.9060573833781795],
  [-8.610839119119674, -6.606058146317633],
  [-0.010838737649947916, -8.706056620438726],
  [-2.1108391191196745, -11.506055857499273],
  [1.489161262350052, -1.506057764847906],
  [-8.110839119119674, -10.206056620438726],
  [-3.010838737649948, 1.0939426166218205],
  [2.089159736471146, -11.606058146317633],
  [-7.310839882059128, -1.506057764847906],
  [-9.010838737649948, -3.7060566204387264],
  [-6.710839500589401, -11.606058146317633],
  [-6.210839500589401, -11.506055857499273],
  [0.8891608808803255, -10.306058909257086],
  [2.089159736471146, -8.506055857499273],
  [-7.210839500589401, -9.006055857499273],
  [1.1891601179408724, -7.606058146317633],
  [-7.910840263528854, -11.306058909257086],
  [-7.910840263528854, -8.40605738337818],
  [2.089159736471146, -6.106058146317633],
  [2.089159736471146, -5.006057764847906],
  [0.5891597364711458, -5.4060573833781795],
  [-4.910840263528854, -10.606058146317633],
  [-7.310839882059128, -7.4060573833781795],
  [-0.5108387376499479, -11.606058146317633],
  [-2.3108398820591276, -10.90605738337818],
  [-3.010838737649948, -9.606058146317633],
  [1.0891597364711458, -6.006057764847906],
  [-2.3108398820591276, 0.39394185368236734],
  [0.5891597364711458, -9.206056620438726],
  [-9.010838737649948, -8.106058146317633],
  [1.989161262350052, -0.9060573833781795],
  [-8.110839119119674, -0.2060566204387264],
  [-7.710839500589401, -9.806058909257086],
  [-7.6108391191196745, -0.806057001908453],
  [-8.910840263528854, 0.19394299809154703],
  [0.5891597364711458, -6.806057001908453],
  [-4.910840263528854, -11.206056620438726],
  [1.1891601179408724, -5.4060573833781795],
  [2.089159736471146, -6.706056620438726],
  [-0.11083911911967448, -11.206056620438726],
  [-5.1108391191196745, -11.606058146317633],
  [0.1891601179408724, -0.5060577648479061],
  [1.789160499410599, -5.606058146317633],
  [0.1891601179408724, 1.493942235152094],
  [-2.910840263528854, -8.006055857499273],
  [-8.710839500589401, -11.40605738337818],
  [-4.1108391191196745, -7.9060573833781795],
  [-1.8108398820591276, -9.306058909257086],
  [-1.8108398820591276, -8.106058146317633],
  [-3.3108398820591276, -8.606058146317633],
  [-1.1108391191196745, -8.706056620438726],
  [-8.910840263528854, -1.306057001908453],
  [-5.6108391191196745, -8.806058909257086],
  [-1.1108391191196745, -11.506055857499273],
  [-7.810839882059128, -2.9060573833781795],
  [-8.010838737649948, -7.306058909257086],
  [1.0891597364711458, -6.806057001908453],
  [1.1891601179408724, -10.706056620438726],
  [2.089159736471146, 0.9939422351520939],
  [-8.410840263528854, -9.606058146317633],
  [-1.4108402635288542, -0.40605738337817954],
  [-1.510838737649948, 0.5939426166218205],
  [-5.1108391191196745, -10.106058146317633],
  [-7.310839882059128, -2.306057001908453],
  [-8.210839500589401, -1.4060573833781795],
  [-5.710839500589401, -9.306058909257086],
  [-8.910840263528854, -0.7060566204387264],
  [-5.310839882059128, -10.806058909257086],
  [-6.1108391191196745, -8.806058909257086],
  [-6.6108391191196745, -8.40605738337818],
  [-9.110839119119674, -11.506055857499273],
  [-2.3108398820591276, -9.206056620438726],
  [1.0891597364711458, -9.106058146317633],
  [1.489161262350052, -9.706056620438726],
  [-8.510838737649948, -2.6060581463176327],
  [-6.210839500589401, -9.40605738337818],
  [-3.8108398820591276, -10.40605738337818],
  [-2.3108398820591276, 3.3939418536823673],
  [0.1891601179408724, 2.5939426166218205],
  [-7.310839882059128, 2.3939418536823673],
  [-5.510838737649948, 3.993942235152094],
  [-6.910840263528854, 2.7939433795612736],
  [-6.010838737649948, 3.5939426166218205],
  [-5.010838737649948, 4.393941853682367],
  [-8.910840263528854, 1.0939426166218205],
  [-3.410840263528854, 5.693942998091547],
  [-8.510838737649948, 1.3939418536823673],
  [-9.310839882059128, 0.7939433795612736],
  [-7.710839500589401, 2.0939426166218205],
  [-8.210839500589401, 1.693942998091547],
  [-6.410840263528854, 3.193942998091547],
  [-4.510838737649948, 4.793943379561274],
  [-3.910840263528854, 5.293943379561274],
  [-6.210839500589401, 5.193942998091547],
  [-10.310839882059128, 1.7939433795612736],
  [-9.910839309854538, 2.0939426166218205],
  [-5.1108391191196745, 6.0939426166218205],
  [-11.010839691324264, 1.193942998091547],
  [-4.810839882059128, 6.493942235152094],
  [-4.410840263528854, 6.793943379561274],
  [-6.6108391191196745, 4.893941853682367],
  [-7.010838737649948, 4.5939426166218205],
  [-7.710839500589401, 3.993942235152094],
  [-9.510838737649948, 2.493942235152094],
  [-8.810839882059128, 2.993942235152094],
  [-8.510838737649948, 3.3939418536823673],
  [-10.610839119119674, 1.493942235152094],
  [-5.910840263528854, 5.493942235152094],
  [-8.110839119119674, 3.693942998091547],
  [-9.210839500589401, 2.693942998091547],
  [-5.510838737649948, 5.793943379561274],
  [-11.310839882059128, 0.8939418536823673],
  [-7.310839882059128, 4.293943379561274],
  [7.189162025289505, -4.806057001908453],
  [5.989161262350052, -10.506055857499273],
  [4.689160117940872, -10.306058909257086],
  [3.8891608808803255, -10.806058909257086],
  [5.289160499410599, -6.806057001908453],
  [7.489161262350052, -8.90605738337818],
  [8.189162025289505, -8.806058909257086],
  [8.389158973531693, -8.206056620438726],
  [7.789160499410599, -5.806057001908453],
  [4.789160499410599, -11.506055857499273],
  [7.589159736471146, -4.206056620438726],
  [5.589159736471146, -4.606058146317633],
  [4.8891608808803255, -4.306057001908453],
  [5.189160117940872, -2.506057764847906],
  [5.489161262350052, -11.40605738337818],
  [6.589159736471146, -9.006055857499273],
  [6.589159736471146, -10.606058146317633],
  [4.289160499410599, -8.90605738337818],
  [4.989161262350052, -8.90605738337818],
  [5.989161262350052, -11.306058909257086],
  [6.689162025289505, -4.006057764847906],
  [6.589159736471146, -11.506055857499273],
  [3.989161262350052, -10.106058146317633],
  [3.289160499410599, -6.506057764847906],
  [7.089159736471146, -11.106058146317633],
  [4.8891608808803255, -5.206056620438726],
  [8.189162025289505, -1.7060566204387264],
  [6.589159736471146, -5.806057001908453],
  [4.089159736471146, -7.306058909257086],
  [4.189160117940872, -2.006057764847906],
  [3.8891608808803255, -6.4060573833781795],
  [6.389158973531693, -4.9060573833781795],
  [3.1891601179408724, -5.606058146317633],
  [3.8891608808803255, -11.606058146317633],
  [3.789160499410599, -5.4060573833781795],
  [4.189160117940872, -9.506055857499273],
  [3.289160499410599, -3.506057764847906],
  [6.289160499410599, -8.306058909257086],
  [5.289160499410599, -10.706056620438726],
  [3.289160499410599, -2.4060573833781795],
  [8.389158973531693, -7.506055857499273],
  [3.289160499410599, -9.40605738337818],
  [7.889158973531693, -7.106058146317633],
  [4.789160499410599, -7.4060573833781795],
  [5.589159736471146, -1.506057764847906],
  [8.489161262350052, -5.806057001908453],
  [7.189162025289505, 0.09394261662182046],
  [5.989161262350052, -9.506055857499273],
  [5.489161262350052, -10.006055857499273],
  [7.789160499410599, -10.606058146317633],
  [3.6891601179408724, 0.19394299809154703],
  [7.589159736471146, -8.006055857499273],
  [8.389158973531693, -10.806058909257086],
  [7.389158973531693, -6.4060573833781795],
  [3.289160499410599, -10.006055857499273],
  [3.3891608808803255, -8.806058909257086],
  [5.8891608808803255, -7.106058146317633],
  [3.3891608808803255, -1.1060581463176327],
  [8.389158973531693, -2.9060573833781795],
  [7.189162025289505, -7.306058909257086],
  [6.789160499410599, -1.806057001908453],
  [5.8891608808803255, -3.806057001908453],
  [4.489161262350052, -11.006055857499273],
  [8.189162025289505, -5.006057764847906],
  [3.8891608808803255, -8.106058146317633],
  [6.889158973531693, -3.1060581463176327],
  [8.389158973531693, -4.206056620438726],
  [7.789160499410599, -3.4060573833781795],
  [5.289160499410599, -6.006057764847906],
  [5.789160499410599, -8.806058909257086],
  [6.689162025289505, -0.806057001908453],
  [4.489161262350052, -5.806057001908453],
  [3.289160499410599, -7.306058909257086],
  [7.189162025289505, -10.306058909257086],
  [8.389158973531693, -6.706056620438726],
  [6.489161262350052, -9.806058909257086],
  [4.489161262350052, -8.206056620438726],
  [7.189162025289505, -5.506057764847906],
  [5.189160117940872, -3.4060573833781795],
  [7.189162025289505, -9.606058146317633],
  [6.189160117940872, -2.7060566204387264],
  [4.089159736471146, -4.706056620438726],
  [4.589159736471146, -6.606058146317633],
  [5.089159736471146, -9.506055857499273],
  [7.589159736471146, -11.40605738337818],
  [5.3891608808803255, -0.0060577648479061],
  [4.189160117940872, -3.806057001908453],
  [3.1891601179408724, -10.706056620438726],
  [8.489161262350052, -9.40605738337818],
  [6.989161262350052, -8.306058909257086],
  [6.089159736471146, -6.306057001908453],
  [3.1891601179408724, -8.106058146317633],
  [6.489161262350052, -7.606058146317633],
  [5.789160499410599, -5.4060573833781795],
  [5.189160117940872, -8.206056620438726],
  [5.589159736471146, -7.806058909257086],
  [8.389158973531693, -10.106058146317633],
  [7.789160499410599, -9.606058146317633],
  [3.289160499410599, -4.506057764847906],
  [8.389158973531693, -11.40605738337818],
  [8.289160499410599, -0.5060577648479061],
  [7.589159736471146, -2.306057001908453],
  [3.1891601179408724, -11.506055857499273],
  [6.689162025289505, -6.806057001908453],
  [4.289160499410599, -3.006057764847906],
  [4.589159736471146, -1.006057764847906],
  [0.1891601179408724, 3.5939426166218205],
  [2.289160499410599, 1.8939418536823673],
  [-1.210839500589401, 4.793943379561274],
  [-2.210839500589401, 5.693942998091547],
  [0.5891597364711458, 3.2939433795612736],
  [-0.8108398820591276, 4.493942235152094],
  [-0.5108387376499479, 4.193942998091547],
  [-1.510838737649948, 5.0939426166218205],
  [-3.3108398820591276, 6.493942235152094],
  [0.9891612623500521, 2.993942235152094],
  [-1.9108402635288542, 5.393941853682367],
  [3.6891601179408724, 0.693942998091547],
  [1.989161262350052, 2.193942998091547],
  [1.6891601179408724, 2.3939418536823673],
  [2.989161262350052, 1.2939433795612736],
  [-2.6108391191196745, 5.993942235152094],
  [1.289160499410599, 2.693942998091547],
  [-3.6108391191196745, 6.793943379561274],
  [2.6891601179408724, 1.5939426166218205],
  [3.3891608808803255, 0.9939422351520939],
  [-4.010838737649948, 7.0939426166218205],
  [-2.910840263528854, 6.193942998091547],
  [-0.11083911911967448, 3.8939418536823673],
  [4.589159736471146, 0.5939426166218205],
  [7.689162025289505, 0.5939426166218205],
  [6.389158973531693, 0.5939426166218205],
  [9.089159736471146, 0.5939426166218205],
  [6.789160499410599, 0.5939426166218205],
  [9.889158973531693, 0.5939426166218205],
  [7.289160499410599, 0.5939426166218205],
  [8.189162025289505, 0.5939426166218205],
  [5.989161262350052, 0.5939426166218205],
  [4.089159736471146, 0.5939426166218205],
  [9.489161262350052, 0.5939426166218205],
  [4.989161262350052, 0.5939426166218205],
  [10.389158973531693, 0.5939426166218205],
  [8.589159736471146, 0.5939426166218205],
  [5.489161262350052, 0.5939426166218205],
  [9.589159736471146, 1.2939433795612736],
  [4.489161262350052, 5.493942235152094],
  [8.489161262350052, 2.193942998091547],
  [6.289160499410599, 3.993942235152094],
  [5.589159736471146, 4.5939426166218205],
  [9.289160499410599, 1.5939426166218205],
  [5.989161262350052, 4.293943379561274],
  [5.189160117940872, 4.893941853682367],
  [8.889158973531693, 1.8939418536823673],
  [4.8891608808803255, 5.193942998091547],
  [4.089159736471146, 5.793943379561274],
  [6.689162025289505, 3.693942998091547],
  [3.789160499410599, 6.0939426166218205],
  [7.089159736471146, 3.3939418536823673],
  [7.389158973531693, 3.0939426166218205],
  [8.189162025289505, 2.493942235152094],
  [7.789160499410599, 2.7939433795612736],
  [9.989161262350052, 0.9939422351520939],
  [2.289160499410599, 8.393941853682367],
  [0.6891601179408724, 8.393941853682367],
  [2.6891601179408724, 8.393941853682367],
  [3.089159736471146, 8.393941853682367],
  [1.0891597364711458, 8.393941853682367],
  [0.28916049941059896, 8.393941853682367],
  [1.5891597364711458, 8.393941853682367],
  [1.989161262350052, 8.393941853682367],
  [0.28916049941059896, 7.493942235152094],
  [0.28916049941059896, 6.193942998091547],
  [0.28916049941059896, 7.0939426166218205],
  [0.28916049941059896, 7.893941853682367],
  [0.28916049941059896, 6.5939426166218205],
  [0.28916049941059896, 5.793943379561274],
  [0.6891601179408724, 5.5939426166218205],
  [1.0891597364711458, 5.393941853682367],
  [2.789160499410599, 5.293943379561274],
  [1.8891608808803255, 5.293943379561274],
  [3.1891601179408724, 5.393941853682367],
  [1.489161262350052, 5.193942998091547],
  [2.289160499410599, 5.293943379561274],
  [3.1891601179408724, 7.393941853682367],
  [3.1891601179408724, 6.793943379561274],
  [3.1891601179408724, 5.793943379561274],
  [3.1891601179408724, 6.193942998091547],
  [3.1891601179408724, 7.893941853682367],
  [1.489161262350052, 6.193942998091547],
  [1.489161262350052, 7.893941853682367],
  [1.489161262350052, 6.693942998091547],
  [1.489161262350052, 5.693942998091547],
  [1.489161262350052, 7.293943379561274],
  [6.789160499410599, -12.106058146317633],
  [5.789160499410599, -12.106058146317633],
  [6.289160499410599, -12.106058146317633],
  [2.089159736471146, -12.106058146317633],
  [-1.710839500589401, -12.106058146317633],
  [0.4891612623500521, -12.106058146317633],
  [-3.8108398820591276, -12.106058146317633],
  [4.689160117940872, -12.106058146317633],
  [-4.310839882059128, -12.106058146317633],
  [-8.510838737649948, -12.106058146317633],
  [4.189160117940872, -12.106058146317633],
  [1.489161262350052, -12.106058146317633],
  [8.989161262350052, -12.106058146317633],
  [-5.810839882059128, -12.106058146317633],
  [-6.910840263528854, -12.106058146317633],
  [-2.710839500589401, -12.106058146317633],
  [-5.310839882059128, -12.106058146317633],
  [7.389158973531693, -12.106058146317633],
  [-0.6108391191196745, -12.106058146317633],
  [-9.110839119119674, -12.106058146317633],
  [-4.810839882059128, -12.106058146317633],
  [-7.410840263528854, -12.106058146317633],
  [5.289160499410599, -12.106058146317633],
  [7.889158973531693, -12.106058146317633],
  [3.6891601179408724, -12.106058146317633],
  [8.389158973531693, -12.106058146317633],
  [3.089159736471146, -12.106058146317633],
  [-3.210839500589401, -12.106058146317633],
  [0.9891612623500521, -12.106058146317633],
  [2.589159736471146, -12.106058146317633],
  [-0.11083911911967448, -12.106058146317633],
  [-2.210839500589401, -12.106058146317633],
  [-9.610839119119674, -12.106058146317633],
  [-1.1108391191196745, -12.106058146317633],
  [-8.010838737649948, -12.106058146317633],
  [-6.410840263528854, -12.106058146317633],
  [2.589159736471146, -9.006055857499273],
  [2.589159736471146, -2.506057764847906],
  [2.589159736471146, -3.006057764847906],
  [2.589159736471146, -5.9060573833781795],
  [2.589159736471146, -6.306057001908453],
  [2.589159736471146, -5.006057764847906],
  [2.589159736471146, -4.506057764847906],
  [2.589159736471146, -9.306058909257086],
  [2.589159736471146, -11.306058909257086],
  [2.589159736471146, -4.106058146317633],
  [2.589159736471146, -11.606058146317633],
  [2.589159736471146, -1.9060573833781795],
  [2.589159736471146, -3.506057764847906],
  [2.589159736471146, -0.0060577648479061],
  [2.589159736471146, -0.7060566204387264],
  [2.589159736471146, -7.506055857499273],
  [2.589159736471146, -7.9060573833781795],
  [2.589159736471146, -8.606058146317633],
  [2.589159736471146, -11.006055857499273],
  [2.589159736471146, -1.306057001908453],
  [2.589159736471146, -8.206056620438726],
  [2.589159736471146, -6.706056620438726],
  [2.589159736471146, -7.106058146317633],
  [2.589159736471146, 0.693942998091547],
  [2.589159736471146, -10.006055857499273],
  [2.589159736471146, -10.706056620438726],
  [2.589159736471146, -5.4060573833781795],
  [2.589159736471146, -10.306058909257086],
  [2.589159736471146, -9.706056620438726],
  [8.989161262350052, -9.506055857499273],
  [8.989161262350052, -10.606058146317633],
  [8.989161262350052, -6.506057764847906],
  [8.989161262350052, -10.006055857499273],
  [8.989161262350052, -8.90605738337818],
  [8.989161262350052, -5.9060573833781795],
  [8.989161262350052, -2.006057764847906],
  [8.989161262350052, -0.2060566204387264],
  [8.989161262350052, -11.606058146317633],
  [8.989161262350052, -11.106058146317633],
  [8.989161262350052, -7.206056620438726],
  [8.989161262350052, -8.306058909257086],
  [8.989161262350052, -5.206056620438726],
  [8.989161262350052, -4.506057764847906],
  [8.989161262350052, -3.7060566204387264],
  [8.989161262350052, -7.806058909257086],
  [8.989161262350052, -1.2060566204387264],
  [8.989161262350052, -2.9060573833781795],
  [-2.910840263528854, 7.0939426166218205],
  [-0.11083911911967448, 7.0939426166218205],
  [-1.1108391191196745, 7.0939426166218205],
  [-0.6108391191196745, 7.0939426166218205],
  [-2.410840263528854, 7.0939426166218205],
  [-3.3108398820591276, 7.0939426166218205],
  [-2.010838737649948, 7.0939426166218205],
  [-1.510838737649948, 7.0939426166218205],
  [-9.610839119119674, -9.106058146317633],
  [-9.610839119119674, -8.106058146317633],
  [-9.610839119119674, -5.206056620438726],
  [-9.610839119119674, -1.9060573833781795],
  [-9.610839119119674, -5.806057001908453],
  [-9.610839119119674, -4.606058146317633],
  [-9.610839119119674, -7.006055857499273],
  [-9.610839119119674, -10.106058146317633],
  [-9.610839119119674, -0.10605814631763266],
  [-9.610839119119674, -11.106058146317633],
  [-9.610839119119674, -4.006057764847906],
  [-9.610839119119674, -11.606058146317633],
  [-9.610839119119674, -3.306057001908453],
  [-9.610839119119674, -7.506055857499273],
  [-9.610839119119674, -8.606058146317633],
  [-9.610839119119674, -10.606058146317633],
  [-9.610839119119674, -6.4060573833781795],
  [-9.610839119119674, -1.006057764847906],
  [-9.610839119119674, -2.6060581463176327],
  [-9.610839119119674, -9.606058146317633],
  [-4.510838737649948, -1.806057001908453],
  [-6.310839882059128, -5.606058146317633],
  [-3.010838737649948, -3.1060581463176327],
  [-1.8108398820591276, -2.1060581463176327],
  [-0.41084026352885417, -2.4060573833781795],
  [-5.810839882059128, -3.506057764847906],
  [-6.210839500589401, -1.4060573833781795],
  [-6.410840263528854, -4.9060573833781795],
  [-5.410840263528854, -5.806057001908453],
  [-3.510838737649948, -5.9060573833781795],
  [-1.210839500589401, -1.506057764847906],
  [-6.410840263528854, -3.806057001908453],
  [-5.310839882059128, -3.6060581463176327],
  [-1.3108398820591276, -6.206056620438726],
  [-2.010838737649948, -1.506057764847906],
  [-0.5108387376499479, -5.706056620438726],
  [-6.210839500589401, -7.106058146317633],
  [-3.710839500589401, -2.1060581463176327],
  [-0.5108387376499479, -4.606058146317633],
  [-4.410840263528854, -6.006057764847906],
  [-5.6108391191196745, -5.006057764847906],
  [-4.210839500589401, -7.006055857499273],
  [-0.5108387376499479, -7.006055857499273],
  [-6.210839500589401, -4.306057001908453],
  [-3.1108391191196745, -4.9060573833781795],
  [-2.510838737649948, -2.6060581463176327],
  [-1.4108402635288542, -4.106058146317633],
  [-4.210839500589401, -2.506057764847906],
  [-5.510838737649948, -4.306057001908453],
  [-4.210839500589401, -3.2060566204387264],
  [-6.410840263528854, -2.4060573833781795],
  [-3.410840263528854, -1.6060581463176327],
  [-6.410840263528854, -1.806057001908453],
  [-3.1108391191196745, -2.306057001908453],
  [-2.510838737649948, -1.9060573833781795],
  [-2.3108398820591276, -3.7060566204387264],
  [-1.8108398820591276, -5.306057001908453],
  [-5.810839882059128, -1.806057001908453],
  [-4.910840263528854, -1.506057764847906],
  [-5.410840263528854, -1.506057764847906],
  [-4.6108391191196745, -3.806057001908453],
  [-6.410840263528854, -3.2060566204387264],
  [-4.810839882059128, -3.006057764847906],
  [-4.810839882059128, -5.106058146317633],
  [-2.510838737649948, -6.206056620438726],
  [-4.010838737649948, -4.206056620438726],
  [-0.41084026352885417, -3.4060573833781795],
  [-5.210839500589401, -6.9060573833781795],
  [-1.210839500589401, -3.1060581463176327],
  [-6.010838737649948, -2.9060573833781795],
  [-2.3108398820591276, -4.506057764847906],
  [-3.1108391191196745, -4.006057764847906],
  [-4.010838737649948, -5.006057764847906],
  [-2.910840263528854, -1.506057764847906],
  [-1.8108398820591276, -7.106058146317633],
  [-4.810839882059128, -4.4060573833781795],
  [-3.6108391191196745, -2.806057001908453],
  [-4.810839882059128, -2.4060573833781795],
  [-5.210839500589401, -2.1060581463176327],
  [-0.41084026352885417, -1.6060581463176327],
  [-1.9108402635288542, -3.006057764847906],
  [-3.1108391191196745, -7.106058146317633],
  [-3.710839500589401, -3.506057764847906],
  [-5.810839882059128, -2.4060573833781795],
  [-1.1108391191196745, -2.2060566204387264],
  [-4.010838737649948, -1.506057764847906],
  [-6.210839500589401, -6.306057001908453],
  [-5.410840263528854, -2.9060573833781795],
  [0.8891608808803255, 16.693942998091547],
  [1.0891597364711458, 17.09394261662182],
  [0.8891608808803255, 16.293942425886957],
  [0.8891608808803255, 15.893942807356684],
  [0.5891597364711458, 15.59394261662182],
  [0.28916049941059896, 15.293942425886957],
  [0.1891601179408724, 14.893942807356684],
  [-0.010838737649947916, 14.59394261662182],
  [-0.11083911911967448, 14.193942998091547],
  [-0.11083911911967448, 13.793942425886957],
  [-0.21083950058940104, 13.393942807356684],
  [-0.010838737649947916, 12.993942235152094],
  [0.28916049941059896, 13.393942807356684],
  [0.28916049941059896, 13.893942807356684],
  [0.28916049941059896, 14.393942807356684],
  [0.6891601179408724, 14.693942998091547],
  [0.6891601179408724, 15.09394261662182],
  [1.0891597364711458, 14.993942235152094],
  [1.0891597364711458, 15.493942235152094],
  [1.489161262350052, 15.293942425886957],
  [1.6891601179408724, 15.693942998091547],
  [1.289160499410599, 15.993942235152094],
  [1.789160499410599, 16.193942998091547],
  [2.1891601179408724, 15.893942807356684],
  [2.789160499410599, 15.59394261662182],
  [2.089159736471146, 15.393942807356684],
  [2.3891608808803255, 14.793942425886957],
  [2.589159736471146, 14.193942998091547],
  [3.089159736471146, 13.59394261662182],
  [2.489161262350052, 13.59394261662182],
  [1.989161262350052, 13.893942807356684],
  [1.8891608808803255, 14.393942807356684],
  [1.6891601179408724, 14.893942807356684],
  [1.289160499410599, 14.493942235152094],
  [0.789160499410599, 14.193942998091547],
  [0.789160499410599, 13.693942998091547],
  [1.3891608808803255, 13.893942807356684],
  [1.1891601179408724, 13.393942807356684],
  [1.5891597364711458, 12.893942807356684],
  [1.789160499410599, 13.393942807356684],
  [2.1891601179408724, 12.993942235152094],
  [2.8891608808803255, 12.993942235152094],
  [3.6891601179408724, 12.293942425886957],
  [2.989161262350052, 12.293942425886957],
  [2.3891608808803255, 12.393942807356684],
  [1.989161262350052, 11.793942425886957],
  [1.5891597364711458, 11.893942807356684],
  [1.789160499410599, 12.393942807356684],
  [1.289160499410599, 12.293942425886957],
  [0.9891612623500521, 12.793942425886957],
  [0.6891601179408724, 13.193942998091547],
  [0.3891608808803255, 12.893942807356684],
  [-0.010838737649947916, 12.59394261662182],
  [0.1891601179408724, 12.393942807356684],
  [0.5891597364711458, 12.493942235152094],
  [0.3891608808803255, 11.993942235152094],
  [0.789160499410599, 12.09394261662182],
  [1.0891597364711458, 11.793942425886957],
  [0.6891601179408724, 11.693942998091547],
  [0.8891608808803255, 11.393942807356684],
  [0.6891601179408724, 10.993942235152094],
  [0.5891597364711458, 10.693942998091547],
  [0.4891612623500521, 10.293942425886957],
  [0.3891608808803255, 9.893942807356684],
  [0.789160499410599, 9.893942807356684],
  [0.8891608808803255, 10.393942807356684],
  [1.0891597364711458, 10.693942998091547],
  [1.1891601179408724, 9.993942235152094],
  [1.0891597364711458, 9.493942235152094],
  [0.4891612623500521, 9.493942235152094],
  [0.5891597364711458, 8.993942235152094],
  [1.489161262350052, 8.993942235152094],
  [0.9891612623500521, 8.993942235152094],
  [1.489161262350052, 9.393942807356684],
  [1.989161262350052, 8.993942235152094],
  [2.3891608808803255, 9.393942807356684],
  [2.6891601179408724, 8.993942235152094],
  [1.989161262350052, 9.493942235152094],
  [1.5891597364711458, 9.793942425886957],
  [1.489161262350052, 10.393942807356684],
  [1.989161262350052, 10.193942998091547],
  [2.3891608808803255, 9.893942807356684],
  [2.8891608808803255, 9.493942235152094],
  [3.289160499410599, 10.193942998091547],
  [3.789160499410599, 10.893942807356684],
  [3.089159736471146, 10.893942807356684],
  [2.589159736471146, 10.493942235152094],
  [1.989161262350052, 10.693942998091547],
  [1.5891597364711458, 10.893942807356684],
  [1.0891597364711458, 11.09394261662182],
  [1.3891608808803255, 11.493942235152094],
  [1.789160499410599, 11.393942807356684],
  [2.1891601179408724, 11.293942425886957],
  [2.6891601179408724, 11.193942998091547],
  [2.589159736471146, 11.693942998091547],
  [3.289160499410599, 11.59394261662182],
  [4.289160499410599, 11.693942998091547],
  [4.289160499410599, 12.693942998091547],
  [3.6891601179408724, 13.193942998091547],
  [3.989161262350052, 13.893942807356684],
  [3.8891608808803255, 14.693942998091547],
  [3.289160499410599, 14.293942425886957],
  [2.989161262350052, 14.893942807356684],
  [3.489161262350052, 15.393942807356684],
  [3.289160499410599, 16.09394261662182],
  [3.989161262350052, 15.993942235152094],
  [4.589159736471146, 15.193942998091547],
  [5.089159736471146, 15.993942235152094],
  [4.3891608808803255, 16.793942425886957],
  [3.589159736471146, 16.693942998091547],
  [2.789160499410599, 16.893942807356684],
  [2.6891601179408724, 16.193942998091547],
  [2.1891601179408724, 16.59394261662182],
  [1.3891608808803255, 16.59394261662182],
  [1.5891597364711458, 16.993942235152094],
  [1.1891601179408724, 17.493942711989252],
  [1.3891608808803255, 17.893942807356684],
  [0.8891608808803255, 17.993942711989252],
  [0.5891597364711458, 18.293942425886957],
  [0.3891608808803255, 18.69394252125439],
  [0.08915973647114583, 19.09394261662182],
  [-0.11083911911967448, 19.59394261662182],
  [-0.3108398820591276, 20.19394252125439],
  [-0.41084026352885417, 20.993942711989252],
  [-0.5108387376499479, 21.793942664305536],
  [-1.210839500589401, 22.493942711989252],
  [-1.8108398820591276, 23.393942568938105],
  [-0.8108398820591276, 23.69394264046368],
  [0.08915973647114583, 22.493942711989252],
  [0.28916049941059896, 20.69394252125439],
  [0.3891608808803255, 19.893942807356684],
  [0.6891601179408724, 19.09394261662182],
  [0.9891612623500521, 18.69394252125439],
  [1.289160499410599, 18.393942807356684],
  [1.6891601179408724, 18.69394252125439],
  [1.289160499410599, 19.19394252125439],
  [0.8891608808803255, 19.69394252125439],
  [0.8891608808803255, 20.293942425886957],
  [0.9891612623500521, 20.993942711989252],
  [0.3891608808803255, 21.59394261662182],
  [0.9891612623500521, 23.293942664305536],
  [1.289160499410599, 22.19394252125439],
  [1.6891601179408724, 21.393942568938105],
  [1.5891597364711458, 20.69394252125439],
  [1.489161262350052, 19.993942711989252],
  [2.3891608808803255, 20.993942711989252],
  [2.289160499410599, 20.09394261662182],
  [1.989161262350052, 19.393942807356684],
  [2.1891601179408724, 18.393942807356684],
  [1.789160499410599, 18.09394261662182],
  [1.6891601179408724, 17.59394261662182],
  [2.1891601179408724, 17.793942425886957],
  [2.289160499410599, 17.19394252125439],
  [2.789160499410599, 17.69394252125439],
  [3.289160499410599, 17.393942807356684],
  [3.989161262350052, 17.493942711989252],
  [3.989161262350052, 18.293942425886957],
  [3.3891608808803255, 17.993942711989252],
  [2.789160499410599, 18.293942425886957],
  [2.489161262350052, 18.893942807356684],
  [2.789160499410599, 19.493942711989252],
  [3.1891601179408724, 20.09394261662182],
  [3.089159736471146, 20.793942425886957],
  [2.1891601179408724, 22.09394261662182],
  [2.289160499410599, 23.19394264046368],
  [3.489161262350052, 23.59394261662182],
  [4.3891608808803255, 22.293942664305536],
  [3.289160499410599, 22.493942711989252],
  [3.6891601179408724, 21.493942711989252],
  [2.8891608808803255, 21.69394252125439],
  [4.989161262350052, 23.19394264046368],
  [6.989161262350052, 23.19394264046368],
  [8.389158973531693, 22.793942664305536],
  [6.889158973531693, 21.893942568938105],
  [5.489161262350052, 22.09394261662182],
  [4.8891608808803255, 21.09394261662182],
  [5.989161262350052, 20.993942711989252],
  [7.289160499410599, 20.993942711989252],
  [6.389158973531693, 19.793942425886957],
  [5.489161262350052, 19.493942711989252],
  [4.989161262350052, 20.19394252125439],
  [3.989161262350052, 20.493942711989252],
  [3.789160499410599, 19.59394261662182],
  [3.289160499410599, 18.893942807356684],
  [4.489161262350052, 18.993942711989252],
  [5.589159736471146, 18.393942807356684],
  [4.789160499410599, 17.893942807356684],
  [5.3891608808803255, 17.09394261662182],
];
